module.exports = __webpack_public_path__ + "img/qr_web.a2975b98.svg";